import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IDigitalPropertyListItem } from '../../../shared/interfaces/digital-property.interface';
import { $digitalProperty } from '../../../shared/constants/digital-properties';
import { UserService } from './user.service';
import { FeatureFlagService } from './feature-flag/feature-flag.service';
import { FeatureFlagCollection } from '../../../shared/interfaces/feature-flag.interface';
import { AngularUtility } from '../utility/angular.utility';

@Injectable({
  providedIn: 'root',
})
export class ContentsquareIntegrationService {
  public contentsquareIntegrationEnabled$: Observable<boolean>;
  constructor(
    private featureFlagService: FeatureFlagService,
    private userService: UserService,
  ) {
    this.contentsquareIntegrationEnabled$ = combineLatest([
      this.featureFlagService.variation$(FeatureFlagCollection.dataEnrichmentMicroserviceIntegration, false),
      this.userService.currentDigitalProperty$,
    ]).pipe(
      map(([featureFlagEnabled, digitalProperty]: [boolean, IDigitalPropertyListItem]): boolean => {
        if (featureFlagEnabled === false) {
          return false;
        }
        return digitalProperty?.[$digitalProperty.contentsquareIntegration] === true;
      }),
      AngularUtility.shareRef(),
    );
  }
}
